<template>
<div class="chapter">
<div class="inner_page">
<div id="prologue">
<div class="story">
<a id="anchor-1-anchor"><p class="ch"><span class="generated-style"> Prologue</span></p>
<p class="body-text-no-indent"><span class="lic">I</span><span class="generated-style"> didn’t know Kim Parkway very well. Sure, she moved into the condo below me. And yes, she reached out to me on a day when I really needed it. She even borrowed something a few days later because she hadn’t completely unpacked yet.</span></p>
<p class="body-text"><span class="generated-style"> What I knew of Kim, I liked. I think she enjoyed me, too. But ultimately, she would have been one of those friends—an acquaintance, really—who fades from your life, remembered once in a while, and even then somewhat foggily.</span></p>
<p class="body-text"><span class="generated-style"> But now I know that Kim Parkway will be in my life forever. I’ll never forget her. Because on a Monday night in November, I found her dead.</span></p>
</a></div><a id="anchor-1-anchor">
</a></div><a id="anchor-1-anchor">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Prologue.vue?df866f56